<script>
import { Sortable } from '@shopify/draggable';
import FavoriteAction from '../FavoriteAction.vue';

export default {
    name: 'MyShortcuts',
    components: {
        FavoriteAction,
    },
    props: {
        shortcutsOrder: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            order: [],
        };
    },
    mounted() {
        this.order = this.shortcutsOrder;
        const myShortcuts = new Sortable(this.$refs.draggable, {
            draggable: '.draggableCard',
            handle: '.mediaCard__dragHandle',
            mirror: {
                constrainDimensions: true,
            },
        });

        myShortcuts.on('sortable:stop', ({ newIndex, oldIndex }) => {
            this.order.splice(newIndex, 0, ...this.order.splice(oldIndex, 1));
            this.updateShortcutsOrder();
        });
    },
    methods: {
        updateShortcutsOrder() {
            axios.post('/api/shortcut-bookmarks/sort', {
                resources: this.order,
            }).catch(error => {
                console.warn(error);
            });
        },
    },
};
</script>
